import { type FC } from "react";

import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";
import { type TooltipContentProps } from "recharts";

import { fontFamily } from "../../../shared/styles";

import { AgeTooltipMetricValue } from "./AgeTooltipMetricValue";

const Container = styled.div`
    ${fontFamily};
    display: flex;
    flex-direction: column;

    padding: 6px 8px;

    color: ${Colors.WHITE};

    background: ${Colors.Black.V200};
    border-radius: 6px;
`;

const Title = styled.div`
    text-align: center;
`;

export const AgeTooltip: FC<TooltipContentProps> = ({ active, payload, label }) => {
    if (!active || payload.length === 0) {
        return null;
    }

    return (
        <Container>
            <Title>{label}</Title>
            {payload.map(({ name, value }) => {
                if (value === undefined || typeof value === "object") {
                    return null;
                }
                return <AgeTooltipMetricValue name={name ?? "?"} value={`${value}%`} key={name} />;
            })}
        </Container>
    );
};
